export const years = Array.from(
    { length: 10 },
    (_, index) => new Date().getFullYear() - index
);

export const semester = [
    { name: 'Enero a Junio', number: 1 },
    { name: 'Julio a Diciembre', number: 2 },
];
